import React from 'react';
import Content from './Content';

export default function MarathonHabits(): React.ReactNode {
  return (
    <div>
      <Content />
    </div>
  );
}
